import { FC } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

import { MainCardSkeleton } from '@shared/ui/Layout/Cards/MainCard'
import { SectionMainCarousel } from '@shared/ui/Layout/SectionMainCarousel'

const Skeleton: FC = () => {
  const listSkeleton = Array.from(Array(3).keys())
  return (
    <BlockBoundary>
      <SectionMainCarousel>
        {listSkeleton.map((_el, index) => (
          <MainCardSkeleton key={index} layout='feature' />
        ))}
      </SectionMainCarousel>
    </BlockBoundary>
  )
}

export default Skeleton
